module.exports = __webpack_public_path__ + "img/2.a80131a0.jpg";